import {
  GridRow,
  GridCol,
  Hide,
  Link,
  Button,
  Heading,
  BodyText,
  List,
  ListItem
} from '@lmig/lmds-react';

import EmptySpace from '../../common/components/empty-space/empty-space-component';
import { useNavigate } from 'react-router-dom';
import styles from './learn-more-page.module.scss';

const LearnMore = () => {
  const navigate = useNavigate();

  const back = () => {
    navigate(-1);
  };

  return (
    <GridRow >
      <GridCol base={12} className={styles.learnMoreContainer}>
        <GridCol lg={6} xl={6}>
          <EmptySpace height={32} />
          <GridRow gutters gutterSize='fixed-16'>
            <GridCol>
              <Link
                caretPosition="left"
                variant="standalone"
                onClick={() => back()}
              >
                Back
              </Link>
            </GridCol>
          </GridRow>
          <Heading type='h3-light' className={styles.mfaHeading}>Learn more about multifactor authentication</Heading>
          <Heading type='h6-small' className={styles.boldParagraph}>What is multifactor authentication?</Heading>
          <BodyText>Multifactor authentication (MFA) is an additional security measure that requires you to provide two or more verification factors to access your Liberty Mutual account. This extra layer of protection makes it harder for unauthorized users to gain access to your account, even if they know your password.</BodyText>
          <Heading type='h6-small' className={styles.boldParagraph}>Why use MFA?</Heading>
          <List>
            <ListItem><strong>Enhance security: </strong>MFA adds a layer of security, helping protect your personal and financial information from potential threats.</ListItem>
            <ListItem><strong>Reduce fraud: </strong>Requiring a second form of verification greatly reduces the chances of fraudulent access.</ListItem>
            <ListItem><strong>Peace of mind: </strong>Knowing your account has enhanced protection helps you manage your insurance needs with confidence.</ListItem>
          </List>
          <Heading type='h6-small' className={styles.boldParagraph}>How do I use MFA?</Heading>
          <BodyText>When you log into your account:</BodyText>
          <List hideBullets className={styles.orderedList}>
            <ListItem><strong>1. Enter </strong>your password</ListItem>
            <ListItem><strong>2. Confirm </strong>your identity: You’ll receive an authentication code via text or email.</ListItem>
            <ListItem><strong>3. Authenticate </strong>your account: Enter the code to complete the login process.</ListItem>
          </List>
          <EmptySpace height={32} />
          <GridRow className={styles.closeButton}>
            <GridCol base={12} md={6} lg={6}>
              <Button
                size="large"
                variant="secondary"
                dynamicWidth
                data-testid="close-button"
                onClick={() => back()}
              >
                Close
              </Button>
            </GridCol>
          </GridRow>
          <EmptySpace height={100} />
          <Hide thresholds={['base', 'sm', 'md']}>
            <EmptySpace height={10} />
          </Hide>
        </GridCol>
      </GridCol>
    </GridRow>
  );
};
export default LearnMore;
